/**
 * Alert card for displaying system-level run errors.
 */

import Alert from "@cloudscape-design/components/alert"

interface SystemErrorAlertProps {
  /**
   * Raw error message string from the run. May be JSON-encoded.
   */
  errorMessage: string
}

/**
 * Renders a system error alert. Attempts to parse JSON to extract a nested errorMessage field,
 * falling back to the raw string.
 */
export default function SystemErrorAlert({ errorMessage }: SystemErrorAlertProps) {
  let displayMessage: string
  try {
    const parsed = JSON.parse(errorMessage)
    displayMessage = parsed.errorMessage || errorMessage
  } catch {
    displayMessage = errorMessage
  }

  return (
    <Alert type="warning" header="System Error">
      {displayMessage}
    </Alert>
  )
}
